import { Drawer, Grid, Typography, styled } from '@mui/material';

export const UploadDocumentsDrawerStyled = styled(Drawer)(({ theme }) => ({
  zIndex: 2000,
  '& .MuiDrawer-paper': {
    width: '960px',
    padding: theme.spacing(8),
    [theme.breakpoints.up('md')]: {
      width: 'auto',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    '& .upload-wrapper': {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
}));

export const UploadDocumentsDrawerInfoStyled = styled(Grid)(({ theme }) => ({
  display: 'flex',
  margin: theme.spacing(4, 0),
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const UploadDocumentsDrawerSubtitleStyled = styled(Typography)(
  ({ theme }) => ({
    color: theme.palette.grey['500'],
    marginBottom: '4rem',
  })
);

export const UploadDocumentsDrawerFooterStyled = styled(Grid)(() => ({
  justifyContent: 'flex-end',
  paddingTop: '24px',
}));
